import React from "react";

export type PointsAcceleratorDisplayMetrics = {
  extraPointsBasedOnTotalLicenses: number;
  regionalModifier: number;
  totalMultiplier: number;
};

interface PointsAcceleratorsSectionProps {
  /** Always shown read-only (matches design: not editable in view or edit mode). */
  displayMetrics: PointsAcceleratorDisplayMetrics;
}

const PointsAcceleratorsSection: React.FC<PointsAcceleratorsSectionProps> = ({
  displayMetrics,
}) => {
  const rows: {
    label: string;
    value: string | number;
  }[] = [
    {
      label: "Extra Points Based on Total Licenses",
      value: displayMetrics.extraPointsBasedOnTotalLicenses,
    },
    {
      label: "Regional Modifier",
      value: displayMetrics.regionalModifier,
    },
    {
      label: "Total Multiplier",
      value:
        typeof displayMetrics.totalMultiplier === "number" &&
        !Number.isInteger(displayMetrics.totalMultiplier)
          ? Number(displayMetrics.totalMultiplier.toFixed(2))
          : displayMetrics.totalMultiplier,
    },
  ];

  return (
    <div className="detail-section">
      <h2>Points Accelerators</h2>
      <div className="form-grid points-accelerators-readonly">
        {rows.map((item, index) => (
          <div key={index} className="form-field">
            <label>{item.label}</label>
            <div className="form-input form-input--readonly" aria-readonly>
              {item.value ?? 0}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PointsAcceleratorsSection;
